import {ApiRequestType} from '../type/ApiRequestType';

export async function apiRequest(
    url: string,
    options: ApiRequestType = {}
): Promise<any> {
    const {method = 'POST', headers = {}, body} = options;

    try {
        console.log("URL IS " + url);
        const response = await fetch(url, {
            method,
            headers: {
                ...headers,
            },
            body,
        });
        console.log("Api called ");

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.text();
        return data;
    } catch (error) {
        console.error('Error during request:', error);
        throw error; // Rethrow error for further handling
    }
}
